import './About.css'
import React from 'react';

const About = () => {
    return (
        <div className='about-me'>
            <div className="me">
                <div className="left">
                    <h1>
                        <p style={{ color: '#ffb400' }}>
                            <span
                                style={{
                                    fontFamily: `'MonteCarlo', cursive`
                                }}
                            >Hi ,</span><br />
                            I'M FOYSAL BIN NOUR.
                        </p>
                        Full-Stack Web Developer
                    </h1>
                    <p>I am a Full-Stack Web Developer. I can build unique looking website for you with both fontend and backend technology. <br />
                        I love to work with community. I am passionate about my work, what I do. You won't see any kind of dishonesty to my passion and to my community. <br />
                        <br />Thanks.

                    </p>
                </div>
                <div className="right">
                    <img src="https://i.ibb.co/syyr3J5/foysal.png" alt="" />
                </div>
            </div>

            {/* goal section */}
            <div className='goal'>
                <h1 style={{ color: '#ffb400' }}>My Goal</h1>
                <p>My goal is Learn more and more, and see myself as a <em><b>Web Architect .</b></em></p>

            </div>
            <div className='goal'>
                <h1 style={{ color: '#ffb400' }}>My Hobbies</h1>
                <p>
                    3D animation and exploring new technologies
                </p>

            </div>


        </div>
    );
};

export default About;